import {
    Container
} from '@mui/material';

const PageContainer = ({ children, mt = 8 }) => {

    return (
        <Container maxWidth="lg" className={'page-container'} sx={{ minHeight: '70vh', mt: mt, pb: { xs: 10, md: 2 } }} >
            {children}
        </Container>
    );
};

export default PageContainer;